/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SalesContactOtherCompany
 */
export interface SalesContactOtherCompany {
  /**
   *
   * @type {string}
   * @memberof SalesContactOtherCompany
   */
  companyId: string;
  /**
   *
   * @type {string}
   * @memberof SalesContactOtherCompany
   */
  companyName: string;
}

/**
 * Check if a given object implements the SalesContactOtherCompany interface.
 */
export function instanceOfSalesContactOtherCompany(
  value: object,
): value is SalesContactOtherCompany {
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  if (!("companyName" in value) || value["companyName"] === undefined)
    return false;
  return true;
}

export function SalesContactOtherCompanyFromJSON(
  json: any,
): SalesContactOtherCompany {
  return SalesContactOtherCompanyFromJSONTyped(json, false);
}

export function SalesContactOtherCompanyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SalesContactOtherCompany {
  if (json == null) {
    return json;
  }
  return {
    companyId: json["companyId"],
    companyName: json["companyName"],
  };
}

export function SalesContactOtherCompanyToJSON(
  json: any,
): SalesContactOtherCompany {
  return SalesContactOtherCompanyToJSONTyped(json, false);
}

export function SalesContactOtherCompanyToJSONTyped(
  value?: SalesContactOtherCompany | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyId: value["companyId"],
    companyName: value["companyName"],
  };
}
